<template>
  <div class="has-text-left">
    <h5 class="title">{{$t("bitcoin_note")}}</h5>
    <p class="subtitle">{{ $t('provider_redirect', { provider: 'Confirmo'}) }}</p>

    <div class="field">
      <p class="control">
        <input
          v-validate="'required'"
          :class="{'input': true, 'is-danger': errors.has('bitcoinAddress') }"
          name="bitcoinAddress"
          type="text"
          :data-vv-as="translations.text.bitcoinAddress"
          :placeholder="translations.text.bitcoinAddress"
          v-model="bitcoinAddress"
        />
        <span
          v-show="errors.has('bitcoinAddress')"
          :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
          class="help is-danger"
        >{{ errors.first('bitcoinAddress') }}</span>
      </p>
    </div>

    <div class="field">
      <label for="OTP">{{$t("otp")}}</label>
      <div class="columns">
        <div class="column is-8">
          <input
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('OTP') }"
            name="OTP"
            type="text"
            :data-vv-as="'OTP'"
            :placeholder="'OTP'"
            v-model="OTP"
          />
          <span
            v-show="errors.has('OTP')"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            class="help is-danger"
          >{{ errors.first('OTP') }}</span>
        </div>
        <div class="column is-4">
          <button
            :disabled="!otpBtnEnabled"
            @click="generateOTP()"
          >{{$t("otp_send_email")}}</button>
        </div>
      </div>
    </div>

    <div class="field has-addons">
      <p class="control">
        <a class="button is-static">{{currencySymbols[User.wallet.currency].symbol}}</a>
      </p>
      <p class="control">
        <input
          v-validate="'required|currency|min_value:10|max_value:20000'"
          :class="{'input': true, 'is-danger': errors.has('amount') }"
          name="amount"
          type="text"
          :data-vv-as="translations.text.amount"
          :placeholder="translations.text.amount"
          v-model="amount"
        />
        <span
          v-show="errors.has('amount')"
          class="help is-danger"
          :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
        >{{ errors.first('amount') }}</span>
      </p>
      <p class="control">
        <a
          class="button is-success"
          @click="withdraw"
        >
          <span class="icon is-small">
            <i
              class="fa fa-check"
              :class="{'ml-10': Language == 'fa' || Language == 'ar'}"
            ></i>
          </span>
          <span>{{$t("withdraw").tTitle()}}</span>
        </a>
      </p>
    </div>
  </div>
</template>

<script>
// import {service} from '../../../app'
import config from '../../../config'
import { mapActions, mapGetters } from 'vuex'
import { service } from '../../../app'

export default {
  data() {
    return {
      amount: 0,
      bitcoinAddress: '',
      otpBtnEnabled: true,
      OTP: '',
      translations: {
        text: {
          amount: this.$t('amount'),
          bitcoinAddress: this.$t('your_bitcoin_address'),
        },
      },
      currencySymbols: config.currencies,
    }
  },
  // watch: {},
  computed: {
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
    }),
  },
  mounted() {},
  methods: {
    withdraw() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$bus.$emit('RequestWithdraw', '/finance/withdraw', {
            amount: String(this.amount),
            userID: this.$store.state.user.info.ID,
            psp: 'confirmo',
            extraInfo: JSON.stringify({ bitcoinAddress: this.bitcoinAddress }),
            OTP: this.OTP,
          })
        }
      })
    },
    generateOTP() {
      service
        .post('/finance/generate-otp', {
          userID: this.$store.state.user.info.ID,
          additionalText: this.$t('otp_additional_text'),
        })
        .then(response => {
          if (response.data.success) {
            this.$toasted.success(this.$t('otp_new_password'))
          } else {
            this.$toasted.error(this.$t('otp_error'))
          }
        })
        .catch(error => {
          this.$toasted.error(this.$t('otp_error') + error)
        })
      this.otpBtnEnabled = false
      setTimeout(
        function () {
          this.otpBtnEnabled = true
        }.bind(this),
        15000
      )
    },
    ...mapActions(['logoLoader/set']),
  },
}
</script>

<style lang="scss" scoped>
label {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// Bitcoin.vue?141b0b6a